var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"class-time"},[_c('div',{staticClass:"clock-icon flex-stretch",domProps:{"innerHTML":_vm._s(require('@/assets/clock.svg'))}}),_c('div',{staticClass:"class-id"},[_vm._v(_vm._s(_vm.timeNum))])])
}
var staticRenderFns = []

export { render, staticRenderFns }